import ParticleEmitter from "../Animations/ParticleEmitter";
import Multiplier from "../Animations/Multiplier";
import BaseAnimSprite from "../Animations/BaseAnimSprite";
import BaseSymbol from "./BaseSymbol";
import JumpAnimation from "../Animations/JumpAnimation";
import * as PIXI from "pixi.js-legacy";
/*
 *  normal symbols with dot numbers on them => 1 ~ 6
 *  don't have animations , only 2 sprites to mix alphas
 */
export default class AdvancedSymbol extends BaseSymbol { // NormalSymbol

    animatedSprite: BaseAnimSprite; //PIXI.AnimatedSprite;
    effect: PIXI.AnimatedSprite;
    particles: ParticleEmitter;    
    multiplier: Multiplier;

    constructor(symbolName: string, index: number, blur: boolean = false) {
        super(symbolName, index, blur);
    }

    // if undefined , create sprite2 , effect , particles and add them to the symbol/"container"
    // !!! multiplier animation is triggered by winController !!!
    create(multiplie: number = 1) {

        if (multiplie > 1) {
            if (this.fireBack === undefined) {
                this.createFireBack();
            } else { console.error(" bunringBack not created !"); }
        }
         
        if (this.animatedSprite === undefined) {
            this.animatedSprite = new BaseAnimSprite(this.name, 0.4);
        } else { console.error(" animatedSprite not created !"); }

        if (this.effect === undefined) {
            this.effect = new BaseAnimSprite("dust", 0.63, { x: 0, y: -20 });
        } else { console.error(" effect not created !"); }

        if (this.particles === undefined) {
            this.particles = new ParticleEmitter(this, this.name);
        } else { console.error(" particles not created !"); }        

        this.addChild(this.animatedSprite, this.effect);

        if (multiplie > 1) {
            this.multiplier = new Multiplier(multiplie);
            this.addChild(this.multiplier);
        }
    }

    async clear() {
        
        this.sprite.visible = true;
        this.sprite.alpha = 1;

        if (this.animatedSprite != undefined) {
            this.animatedSprite.stop();
            this.animatedSprite.visible = false;                     
            this.animatedSprite.destroy({ children: true , baseTexture: true });            
            this.animatedSprite = undefined;            
        }        
        
        if (this.fireBack) {
            this.clearFireBack();
        }

        if (this.effect != undefined) {
            this.effect.visible = false;
            this.effect.stop();
            this.effect.destroy({ children: true , baseTexture: true });            
            this.effect = undefined;            
        }

        if (this.particles != undefined) {
            //this.particles.particleContainer.removeChildren();
            this.particles.stopEmitting();
            this.particles = undefined;            
        }

        if (this.multiplier != undefined) {
            this.multiplier.visible = false;
            this.multiplier.destroy({ children: true , baseTexture: true });
            this.multiplier = undefined;            
        }

        // this.removeChildren();
        // this.removeChild(this.animatedSprite, this.effect, this.multiplier); // this.particles.emitter,
        this.addChild(this.sprite);
    }

    async play() {

        if (this.multiplier !== undefined) {
            this.playFireBack();
        }

        await JumpAnimation.jump(this.sprite, this.effect);
        this.particles.startEmitting();        
        await this.animatedSprite.animate();
        //this.particles.stopEmitting();      
    }
}
